import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ClientDetail from './pages/ClientDetail';
import OnboardingFlow from './pages/OnboardingFlow';
import AgreementClients from './agreements/AgreementClients';
import ExistingClientForm from './agreements/ExistingClientForm';
import AgreementHistory from './agreements/AgreementHistory';
import ClientAgreementReview from './agreements/ClientAgreementReview';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user has valid token
    const token = localStorage.getItem('auth_token');
    if (token) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('auth_token', token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Public onboarding route */}
        <Route path="/onboarding/:token" element={<OnboardingFlow />} />
        <Route path="/agreement" element={<ClientAgreementReview />} />
        <Route path="/admin/agreements" element={isAuthenticated ? <AgreementClients /> : <Navigate to="/admin/login" />} />
        <Route path="/admin/agreements/new" element={isAuthenticated ? <ExistingClientForm /> : <Navigate to="/admin/login" />} />
        <Route path="/admin/agreements/:clientId" element={isAuthenticated ? <AgreementHistory /> : <Navigate to="/admin/login" />} />
        <Route path="/admin/agreements/:clientId/draft" element={isAuthenticated ? <ExistingClientForm /> : <Navigate to="/admin/login" />} />
        <Route path="/admin/agreements/:clientId/draft/:agreementId" element={isAuthenticated ? <ExistingClientForm /> : <Navigate to="/admin/login" />} />
        
        {/* Admin routes */}
        <Route 
          path="/admin/login" 
          element={
            isAuthenticated ? 
            <Navigate to="/admin/dashboard" /> : 
            <AdminLogin onLogin={handleLogin} />
          } 
        />
        <Route 
          path="/admin/dashboard" 
          element={
            isAuthenticated ? 
            <AdminDashboard onLogout={handleLogout} /> : 
            <Navigate to="/admin/login" />
          } 
        />
        <Route 
          path="/admin/clients/:clientId" 
          element={
            isAuthenticated ? 
            <ClientDetail onLogout={handleLogout} /> : 
            <Navigate to="/admin/login" />
          } 
        />
        
        {/* Default redirects */}
        <Route path="/" element={<Navigate to="/admin/login" />} />
        <Route path="*" element={<Navigate to="/admin/login" />} />
      </Routes>
    </Router>
  );
}

export default App;